import { withInstall } from '@xzx-design/utils'
import _Divider from './src/divider.vue'

export const Divider = withInstall(_Divider)
export default Divider

export * from './src/divider'
